<script>

    import { toast } from 'bulma-toast'
    import { tilPricingStore, tilPricingsStore, modalStore } from '../stores'

    import TilService from '../$services/til.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'
    import SelectOwners from '../$components/select.owners.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import { ZONE_OPTIONS } from './zones'

    const serviceOptions = [
        { value: 'Express', text: 'Express' },
        { value: 'Metro Express', text: 'Metro Express' },
    ]

    let data = {
        ownerId: $tilPricingStore.ownerId,
        service: $tilPricingStore.service,
        volumetricMin: $tilPricingStore.volumetricMin,
        volumetricMax: $tilPricingStore.volumetricMax,
        pickupZoneOperative: $tilPricingStore.pickupZoneOperative,
        deliveryZoneOperative: $tilPricingStore.deliveryZoneOperative,
        pickupIATA: $tilPricingStore.pickupIATA,
        deliveryIATA: $tilPricingStore.deliveryIATA,
        price: $tilPricingStore.price,
    }

    let loading = false

    async function updateTilPricing() {

        loading = true
        const resp = await TilService.updateTilPricing($tilPricingStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        tilPricingsStore.replace(resp.data)
        toast({message: 'Precio TIL actualizado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={updateTilPricing} {loading}>

    <div class="columns">
        <div class="column">
            <SelectOwners bind:ownerId={data.ownerId} label="Propietario" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Select bind:value={data.service} label="Servicio" text="Servicio" options={serviceOptions} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo" min="0" step="0.1" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo" min="0" step="0.1" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Select bind:value={data.pickupZoneOperative} label="Zona origen" text="Zona origen" options={ZONE_OPTIONS} />
        </div>
        <div class="column">
            <Select bind:value={data.deliveryZoneOperative} label="Zona destino" text="Zona destino" options={ZONE_OPTIONS} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.pickupIATA} label="IATA origen" placeholder="IATA origen" required={false} />
        </div>
        <div class="column">
            <InputText bind:value={data.deliveryIATA} label="IATA destino" placeholder="IATA destino" required={false} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.price} label="Precio" placeholder="Precio" step="0.01" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="tilPricing_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>

</Form>
